import { Spin } from "antd";

import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 56, color: "#00a287" }} spin />
);

export function Spinner({ tip = "" }) {
  return (
    <div className="loader-spinner">
      <Spin indicator={antIcon} />
      <span className="loader-spinner__tip">{tip}</span>
    </div>
  );
}
